/**
 * Renders error box at top with regard to general errors from async call to server.
 * Toggle the errorToggle to get it to bounce the msg.
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Message, Transition } from '@adc/ui-core'
import environments from '@adc/core-utils/src/helpers/environments'

class ErrorAsyncSummary extends Component {
  static propTypes = {
    submitFailed: PropTypes.bool,
    error: PropTypes.string,
    errorToggle: PropTypes.bool,
  }

  componentDidMount() {
    // scroll to top so that async error message is noticable when appears
    this.scrollToTop()
  }

  componentDidUpdate(prevProps) {
    // avoid scroll when other props changed, only if errorToggle switched
    if (this.props.errorToggle !== prevProps.errorToggle) {
      this.scrollToTop()
    }
  }

  scrollToTop = () => {
    if (environments.canUseDom() && document) {
      const container = document.querySelector('#main-content')
      if (container) container.scrollTop = 0
    }
  }

  render() {
    const { submitFailed, error, errorToggle } = this.props
    if (!submitFailed || !error) {
      return null
    }

    // visible below is used to start animation - not actually hide/show
    return (
      <Transition animation='pulse' duration={300} visible={errorToggle}>
        <Message negative data-elm-id='async_error_summary'>
          <Message.Header>Uh-oh... Failed to Save. {error}</Message.Header>
        </Message>
      </Transition>
    )
  }
}

export default ErrorAsyncSummary
